<ng-container *ngFor="let kontoverbindung of kontoverbindungen; let i = index; let last = last">
  <h4 *ngIf="hasMultipleAccounts()">
    {{ 'kontoverbindungen.view.account-number' | translate : { number: i + 1 } }}
  </h4>
  <div class="row mt-7">
    <div class="col col-md-4">
      {{ 'kontoverbindungen.view.account-owner' | translate }}
    </div>
    <div class="col-8 col-md text-right order-md-last">
      <a href="javascript:void(0)" (click)="onEditClick(i)">
        <sux-icon class="sux-icon-first" icon="edit"></sux-icon>
        {{ 'kontoverbindungen.view.change-link' | translate }}
      </a>
    </div>
    <div class="col-12 col-md-auto sux-text-medium mt-0 mb-10 mb-md-5">
      {{ kontoverbindung.inhaber }}
    </div>
  </div>

  <div class="row">
    <div class="col col-md-4">
      {{ 'kontoverbindungen.view.iban' | translate }}
    </div>
    <div class="col-8 col-md text-right order-md-last"></div>
    <div class="col-12 col-md-auto sux-text-medium mt-0 mb-10 mb-md-5">
      {{ kontoverbindung.iban }}
    </div>
  </div>
  <hr *ngIf="!last" />
</ng-container>
